import React, { useEffect, useState } from 'react';
import { Card, Col, Container, Row, CardBody, CardHeader, Nav, NavItem, NavLink } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { createSelector } from 'reselect';
import { getBookingDetailDataLoading } from 'store/actions';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import Spinners from 'components/Common/Spinner';
import getBadgesData from 'components/Common/BadgesData';
import getShippingLineLinkUrl from 'helpers/shipping_line_url';
import CountryFlag from 'common/countryFlag';
import moment from 'moment';
import BookingContainers from './BookingContainers';
import BookingDocuments from './BookingDocuments';
import BookingInvoices from './BookingInvoices';
const BookingDetails = () => {
	let { bookingId } = useParams();
	const [activeTab, setActiveTab] = useState('containers');
	const [totaldayscount, setTotaldayscount] = useState(0);
	const [passedDays, setPassedDays] = useState(0);
	const toggle = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	const BookingsProperties = createSelector(
		state => state.Bookings,
		bookings => ({
			isLoading: bookings.booking_detail_data_loading,
			dataValue: bookings.booking_detail_data,
			prefilledData: bookings.create_booking_preset_value_data
		})
	);

	const { isLoading, dataValue, prefilledData } = useSelector(BookingsProperties);

	const UserRoleProperties = createSelector(
		state => state.Login,
		role => ({
			userRole: role.userRole
		})
	);

	const LayoutProperties = createSelector(
		state => state.Layout,
		layout => ({
			layoutType: layout.layoutModeType
		})
	);

	const { layoutType } = useSelector(LayoutProperties);

	const { userRole } = useSelector(UserRoleProperties);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getBookingDetailDataLoading({ bookingId }));
	}, [bookingId]);

	useEffect(() => {
		if (dataValue && Object.keys(dataValue).length > 0) {
			let data = dataValue[0];
			var startDate = moment(data.etdDate);
			var endDate = moment(data.etaDate);
			var currentDate = moment();
			var result = endDate.diff(startDate, 'days');
			var difffromtoday = currentDate.diff(startDate, 'days');

			if (result > 0) {
				setTotaldayscount(result);
			}
			if (difffromtoday > 0) {
				setPassedDays(difffromtoday);
			}
		}
	}, [dataValue]);

	const renderTabContent = (activeTab, dataValue) => {
		switch (activeTab) {
			case 'task':
				return <></>;
			case 'price':
				return <></>;
			case 'containers':
				return <BookingContainers bookingId={bookingId} />;
			case 'parties':
				return <></>;
			case 'invoices':
				return <BookingInvoices />;
			case 'documents':
				return <BookingDocuments bookingId={bookingId} />;
			case 'outlook-emails':
				return <></>;
			case 'logs':
				return <></>;
			default:
				return null;
		}
	};

	return (
		<React.Fragment>
			<div className="page-content">
				<Container fluid>
					<Breadcrumbs title={'Bookings'} titleLink={'/bookings'} breadcrumbItem={'Booking Details'} />

					{isLoading ? (
						<Row>
							<Col xs="12">
								<Spinners setLoading={() => {}} />{' '}
							</Col>
						</Row>
					) : (
						<>
							{dataValue && Object.keys(dataValue).length > 0 ? (
								<>
									<Row>
										<Col xs="6" xl="3">
											<Card style={{ borderRadius: '0px 0px 10px 10px', height: 180 }}>
												<CardHeader className="bg-primary" style={{ borderRadius: '10px 10px 0 0' }}>
													<div className="d-flex ">
														<div className="flex-grow-1">
															<h4 className="card-title text-white mt-1 font-size-12">Booking</h4>
														</div>
													</div>
												</CardHeader>
												<CardBody>
													<div className="mb-1 text-center">
														<p className="card-text">
															<div className="mt-4">
																<div>Booking Id : {bookingId} </div>
																<div className="mt-2"> Containers : {dataValue[0]?.noOfContainer}</div>
															</div>
														</p>
													</div>
												</CardBody>
											</Card>
										</Col>
										<Col xs="6" xl="3">
											<Card style={{ borderRadius: '0px 0px 10px 10px', height: 180 }}>
												<CardHeader className="bg-primary" style={{ borderRadius: '10px 10px 0 0' }}>
													<div className="d-flex ">
														<div className="flex-grow-1">
															<h4 className="card-title text-white mt-1 font-size-12">Customer Reference</h4>
														</div>
													</div>
												</CardHeader>
												<CardBody>
													<div className="mb-1 text-center">
														<p className="card-text">
															<div className="mt-4">{dataValue[0]?.customerReferenceNumber}</div>
														</p>
													</div>
												</CardBody>
											</Card>
										</Col>
										<Col xs="6" xl="3">
											<Card style={{ borderRadius: '0px 0px 10px 10px', height: 180 }}>
												<CardHeader className="bg-primary" style={{ borderRadius: '10px 10px 0 0' }}>
													<div className="d-flex ">
														<div className="flex-grow-1">
															<h4 className="card-title text-white mt-1 font-size-12">Shipping Line</h4>
														</div>
													</div>
												</CardHeader>
												<CardBody>
													<div className="mb-1 text-center">
														<p className="card-text mt-4">
															{getShippingLineLinkUrl(
																dataValue[0]?.shippingLineData?.companyname,
																dataValue[0]?.bookingNumber
															)}
														</p>
													</div>
												</CardBody>
											</Card>
										</Col>
										<Col xs="6" xl="3">
											<Card style={{ borderRadius: '0px 0px 10px 10px', height: 180 }}>
												<CardHeader className="bg-primary" style={{ borderRadius: '10px 10px 0 0' }}>
													<div className="d-flex ">
														<div className="flex-grow-1">
															<h4 className="card-title text-white mt-1 font-size-12">Price Note</h4>
														</div>
													</div>
												</CardHeader>
												<CardBody>
													<div className="mb-1 text-center">
														<p className="card-text">
															<div className="mt-4 ">{dataValue[0]?.priceNotes}</div>
														</p>
													</div>
												</CardBody>
											</Card>
										</Col>
									</Row>
									<Row>
										<Col xs="12" xl="12">
											<Card style={{ borderRadius: '0px 0px 10px 10px' }}>
												<CardHeader className="bg-primary" style={{ borderRadius: '10px 10px 0 0' }}>
													<div className="d-flex ">
														<div className="flex-grow-1">
															<h4 className="card-title text-white mt-1 font-size-12">Location</h4>
														</div>
													</div>
												</CardHeader>
												<CardBody>
													<Row className="mt-4 mb-4">
														<Col xs="2" className="mt-3 text-center">
															{dataValue[0]?.loadingLocation !== '' ? (
																<>
																	<div className="font-size-10 mt-3">Loading Point</div>
																	<div className="font-size-10 vertical-align-center text-center justify-content-center align-items-center mt-2">
																		<b>{dataValue[0]?.loadingLocation}</b>
																	</div>
																</>
															) : null}
														</Col>
														<Col
															xs="8"
															style={
																layoutType === 'dark' || bookingId == dataValue[0]?._id
																	? { height: '135px', backgroundColor: 'rgb(34 39 54)', borderRadius: '10px' }
																	: { height: '135px', backgroundColor: '#e0e5fb', borderRadius: '10px' }
															}
														>
															<Row>
																<Col xs="6" style={{ paddingLeft: '15px' }}>
																	<div className="font-size-10 mt-3">Port of loading</div>
																	<div>
																		<b className="font-size-10">
																			{dataValue[0]?.polLocation} {CountryFlag[dataValue[0]?.polCountry.toLowerCase()]}
																		</b>
																		<br />
																		<span className="font-size-10">
																			Departing {moment(dataValue[0]?.etdDate).format('DD-MM-YYYY')}
																		</span>
																	</div>
																</Col>
																<Col xs="6" style={{ textAlign: 'right', paddingRight: '15px' }}>
																	<div className="font-size-10 mt-3">Port of discharge</div>
																	<div>
																		<b className="font-size-10">
																			{dataValue[0]?.podLocation} {CountryFlag[dataValue[0]?.podCountry.toLowerCase()]}
																		</b>
																		<br />
																		<span className="font-size-10">
																			Arriving {moment(dataValue[0]?.etaDate).format('DD-MM-YYYY')}
																		</span>
																	</div>
																</Col>
															</Row>
															<div className="text-center justify-content-center align-items-center">
																{totaldayscount > 0 ? (
																	<table className="align-middle mt-2 text-center">
																		<tbody>
																			<tr className="text-center">
																				{[...Array(totaldayscount).keys()].map((count, index) => {
																					let eachday = count + 1;
																					let selectedColor = '#fff';

																					if (eachday <= passedDays) {
																						selectedColor = '#464646';
																					}
																					return (
																						<td
																							key={index + 'days' + count}
																							style={{
																								display: 'table-cell',
																								border: '1px #d1d1d1 solid',
																								height: '12px',
																								lineHeight: '1',
																								overflow: 'hidden',
																								padding: '0',
																								textAlign: 'center',
																								width: '15px',
																								backgroundColor: selectedColor
																							}}
																						></td>
																					);
																				})}
																				<td></td>
																			</tr>
																		</tbody>
																	</table>
																) : null}
															</div>
															<div className="text-center font-size-10 w-100 mt-2">
																Total <b>{totaldayscount}</b> Days
															</div>
														</Col>
														<Col xs="2" className="mt-3 text-center">
															{dataValue[0]?.fpodLocation !== '' &&
															dataValue[0]?.fpodLocation !== dataValue[0]?.podLocation ? (
																<>
																	<div className="font-size-10 mt-3">Place of delivery</div>
																	<div className="font-size-10 vertical-align-center text-center justify-content-center align-items-center mt-2">
																		<b>{dataValue[0]?.fpodLocation}</b>
																	</div>
																</>
															) : null}
														</Col>
													</Row>
												</CardBody>
											</Card>
										</Col>
									</Row>
									<Row>
										<Col xs="12">
											<Nav tabs className="nav-tabs-custom">
												<NavItem>
													<NavLink
														className={activeTab === 'containers' ? 'active' : ''}
														onClick={() => {
															toggle('containers');
														}}
													>
														<span className="d-block d-sm-none">
															<i className="fas fa-box"></i>
														</span>
														<span className="d-none d-sm-block">
															<i className="fas fa-box me-2"></i> Containers & VGM
														</span>
													</NavLink>
												</NavItem>

												<NavItem>
													<NavLink
														className={activeTab === 'documents' ? 'active' : ''}
														onClick={() => {
															toggle('documents');
														}}
													>
														<span className="d-block d-sm-none">
															<i className="fas fa-file"></i>
														</span>
														<span className="d-none d-sm-block">
															<i className="fas fa-file me-2"></i>Documents
														</span>
													</NavLink>
												</NavItem>
												<NavItem>
													<NavLink
														className={activeTab === 'invoices' ? 'active' : ''}
														onClick={() => {
															toggle('invoices');
														}}
													>
														<span className="d-block d-sm-none">
															<i className="fas fa-receipt"></i>
														</span>
														<span className="d-none d-sm-block">
															<i className="fas fa-receipt me-2"></i> Charges & Invoices
														</span>
													</NavLink>
												</NavItem>
											</Nav>
										</Col>
									</Row>
									<Row>
										<Col xs="12" className="p-3">
											{renderTabContent(activeTab, dataValue)}
										</Col>
									</Row>
								</>
							) : (
								<Row>
									<Col xs="12" className="p-3 text-center">
										No Details Found{' '}
									</Col>
								</Row>
							)}
						</>
					)}
				</Container>
			</div>
		</React.Fragment>
	);
};

export default BookingDetails;
